<div>
    <div class="d-flex align-items-center border-bottom py-2">
        <input type="radio" class="svg-18" id="{{ 'rdoDaily' + fieldKey }}" name="{{ 'reminderFrequency' + fieldKey }}"
            [checked]="formControl.value === ReminderFrequencyEnum.Daily"
            (change)="selectFrequency(ReminderFrequencyEnum.Daily)">
        <span class="f-14 mb-0 padding-left-10 cursor-pointer" (click)="selectFrequency(ReminderFrequencyEnum.Daily)">{{ field.templateOptions.labelDaily }}</span>
    </div>

    <div class="d-flex align-items-center border-bottom py-2">
        <input type="radio" class="svg-18" id="{{ 'rdoWeekly' + fieldKey }}" name="{{ 'reminderFrequency' + fieldKey }}"
            [checked]="formControl.value === ReminderFrequencyEnum.Weekly"
            (change)="selectFrequency(ReminderFrequencyEnum.Weekly)">
        <span class="f-14 mb-0 padding-left-10 cursor-pointer" (click)="selectFrequency(ReminderFrequencyEnum.Weekly)">{{ field.templateOptions.labelWeekly }}</span>
        <ng-select class="solo-dropdown margin-left-10" style="width: 200px;bottom: 5px;left: 25px;" [items]="field.templateOptions.weekdayOptions"
            bindLabel="value" bindValue="id" [clearable]="false"
            [disabled]="formControl.value !== ReminderFrequencyEnum.Weekly"
            [(ngModel)]="model.outstandingReminderDayOfWeek" [ngModelOptions]="{standalone: true}"
            (change)="onValueChange()">
        </ng-select>
    </div>

    <div class="d-flex align-items-center py-2">
        <input type="radio" class="svg-18" id="{{ 'rdoMonthly' + fieldKey }}" name="{{ 'reminderFrequency' + fieldKey }}"
            [checked]="formControl.value === ReminderFrequencyEnum.Monthly"
            (change)="selectFrequency(ReminderFrequencyEnum.Monthly)">
        <span class="f-14 mb-0 padding-left-10 cursor-pointer" (click)="selectFrequency(ReminderFrequencyEnum.Monthly)">{{ field.templateOptions.labelMonthly }}</span>
        <ng-select class="solo-dropdown margin-left-10" style="width: 200px;bottom: 5px;left: 18px;" [items]="field.templateOptions.dayOfMonthOptions"
            bindLabel="value" bindValue="id" [clearable]="false"
            [disabled]="formControl.value !== ReminderFrequencyEnum.Monthly"
            [(ngModel)]="model.outstandingReminderDayOfMonth" [ngModelOptions]="{standalone: true}"
            (change)="onValueChange()">
        </ng-select>
    </div>
</div>
